import { render, staticRenderFns } from "./ANxALxAcademSuperiorPage.vue?vue&type=template&id=da918d0c"
import script from "./ANxALxAcademSuperiorPage.vue?vue&type=script&lang=js"
export * from "./ANxALxAcademSuperiorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports